var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Sluiten"),React.createElement("defs",{"key":1}),React.createElement("path",{"stroke":"currentColor","fill":"none","strokeLinecap":"square","strokeMiterlimit":"10","strokeWidth":"2px","className":"close-line","d":"m11.05 11.05 9.9 9.9M20.95 11.05l-9.9 9.9","key":2})]);
}

Close.defaultProps = {"aria-hidden":"true","viewBox":"0 0 32 32"};

module.exports = Close;

Close.default = Close;
